'use strict';

const isMobile = window.matchMedia("(max-width: 580px)").matches;

const toggleDropdown = () => {
    let categoryDropdown = '.left-nav-template .js-open-blog-subnav.dropdown-trigger';

    $(document).on('click', categoryDropdown, function (e) {
        $(e.target).closest('.dropdown-trigger').next('.accordion').slideToggle();
        setTimeout(function () {
            adjustBackLinkPosition();
        }, 400);
    });
}

const initRelatedArticlesCarousal = () => {
    let $carousalWrapper = $('.related-carousel-wrapper');

    if ($carousalWrapper.length) {
        $carousalWrapper.find('.related-tutorial-wrapper').slick({
            arrows: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        centerMode: true,
                        centerPadding: '15%',
                        slidesToShow: 1,
                    }
                }
            ]
        });
    }

}

const adjustBackLinkPosition = () => {
    let $articlePage = $('.drunk-mag-article');

    if ($articlePage.length) {
        let $backLink = $articlePage.find('.back-link');
        let $backLinkText = $articlePage.find('.back-link-text');
        let articleHeadingPos = document.querySelector('.article-details').offsetTop;

        if (isMobile) {
            $backLinkText.css('top', articleHeadingPos + 20 + 'px');
        } else {
            $backLink.css('top', articleHeadingPos + 'px');
        }
    }

    $(window).on('resize', adjustBackLinkPosition);

}

export default {
    init: function () {
        toggleDropdown();
        initRelatedArticlesCarousal();
        adjustBackLinkPosition();
    }
}